export default {
    nl: {
        intro: {
            subtitle: 'Customer journey',
            title: 'Klanten kennen.',
            contact: 'Neem contact op',
            image: 'https://23g-website.s3.eu-central-1.amazonaws.com/services/customer-journey/hero.jpg',
        },
        type: 'Customer journey',
        title: 'Stimuleer de customer journey: Van interactie tot aankoop',
        description:
            'Krijg inzicht in de customer journey van stap tot stap. We optimaliseren elke stap voor optimale gebruikerservaring en klantloyaliteit.',
        content: [
            {
                type: 'text',
                title: 'Customer journey',
                content:
                    'Tijdens onze Design Sprints komt het vaak ter sprake; welke reis legt de klant af om een product of dienst aan te schaffen? Als ervaren optimisten zien we bij 23G elke stap van de klant als een kans om te tonen dat het beter, efficiënter en gebruiksvriendelijker kan. Want de ultieme klantbeleving? Die is onlosmakelijk verbonden met een superieure gebruikerservaring (UI/UX design), iets waar wij als internetbureau dagelijks naar streven. Door de klantreis te visualiseren, vinden we gebieden die vragen om verbetering. Dit doen we niet alleen tijdens Design Sprints maar gebeurt ook tijdens UX research. Door middel van kwalitatief onderzoek brengen we alles in kaart: de sterke kanten, pijnpunten, mogelijke kansen en de behoeften van een gebruiker.',
            },
            {
                type: 'images',
                images: ['https://23g-website.s3.eu-central-1.amazonaws.com/services/meeting.webp'],
            },
            {
                type: 'text',
                title: 'De customer journey onder de loep',
                content:
                    'Bij het maken van een customer journey map brengen we de volledige klantreis in kaart. Samen met jou en de doelgroep duiken we in elk touchpoint uit de klantreis. Per touchpoint voelen we wat jouw klanten voelen en kiezen we hier gezamenlijk een emotie bij. Dit beoordelen we tussen de emoties ‘heel blij’ en ‘niet blij’. Hierna bespreken we wat de verwachtingen en ervaringen zijn van de doelgroep.',
            },
            {
                type: 'quote',
                content:
                    'Door de klantreis te visualiseren, vinden we gebieden die vragen om verbetering.',
            },
            {
                type: 'text',
                title: 'De klantreis optimaliseren',
                content: `
                    Met de inzichten uit de klantreis stellen we samen vast waar we moeten optimaliseren en hoe we dat gaan doen. Soms is dat in de technische diepten van een product met back-end development, soms vraagt het om wat extra UX-speurwerk en andere keren is een simpele design-tweak al genoeg.
                    <br><br>
                    Bij elke stap van de klantreis duiken we dieper in om het pad vloeiender en intuïtiever te maken. Het perfecte traject is er voor ons één waar de klant zich voortdurend begrepen en gewaardeerd voelt.
                `,
            },
            {
                type: 'case',
                case: 'sonnema',
            },
        ],
        related_services: ['design-sprint', 'strategy-session', 'client-portal'],
        contact: {
            title: '',
            employee: 'jack',
        },
    },
    en: {},
};
